import React from 'react';
import NotFoundPartial from 'swag-client-common/components/partials/not-found';
import Page from '../../../page';
export default class NotFound extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(Page, null, /*#__PURE__*/React.createElement(NotFoundPartial, null));
  }
}